import {
  Box,
  Tab,
  Tabs
} from "@mui/material";
import { useState } from "react";
import useNotification from "../../hooks/useNotification";
import ApprovalTab from "./manage-tabs/ApprovalTab";
import OpnamesTab from "./manage-tabs/OpnamesTab";

type ManageTab = "opnames" | "approval";

export default function OpnameManage() {
  const [currentTab, setCurrentTab] = useState<ManageTab>("opnames");

  const handleTabChange = (event: React.SyntheticEvent, newValue: ManageTab) => {
    setCurrentTab(newValue);
  };

  const renderContent = () => {
    switch (currentTab) {
      case "opnames":
        return <OpnamesTab />;
      case "approval":
        return <ApprovalTab />;
      default:
        return null;
    }
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
        <Tabs value={currentTab} onChange={handleTabChange}>
          <Tab label="Opnames" value="opnames" />
          <Tab label="Approval" value="approval" />
        </Tabs>
      </Box>
      {renderContent()}
    </Box>
  );
}
